import * as types from 'constants/ActionTypes';
import initialState from 'config/initialState';

export default function auth(state = initialState.auth, action) {
  switch (action.type) {

    case types.LOGIN.REQUEST:
      return Object.assign({}, state, {
        loggingIn: true,
        isLoggedIn: false,
        currentUser: null,
      });

    case types.LOGIN.FAILURE:
      return Object.assign({}, state, {
        loggingIn: false,
        isLoggedIn: false,
        error: action.error,
        currentUser: null,
      });

    case types.LOGIN.SUCCESS:
      return Object.assign({}, state, {
        loggingIn: false,
        error: null,
        isLoggedIn: true,
        currentUser: action.response.pk,
      });

    case types.LOGOUT.REQUEST:
      return Object.assign({}, state, {
        loggingOut: true,
      });

    case types.LOGOUT.FAILURE:
      return Object.assign({}, state, {
        loggingOut: false,
        error: action.error,
      });

    case types.LOGOUT.SUCCESS:
      return Object.assign({}, state, {
        loggingOut: false,
        error: null,
        isLoggedIn: false,
        currentUser: null,
      });

    case types.CURRENT_USER.SUCCESS:
      return Object.assign({}, state, {
        loggingIn: false,
        error: null,
        isLoggedIn: true,
        currentUser: action.response.pk,
      });

    default:
      return state;

  }
}



// WEBPACK FOOTER //
// ./app/scripts/reducers/AuthReducers.js